import { MedicineSelectorIcd10Code } from './medicineSelector.types';

export const sortMedicineSelectorIcd10Code = (
   icd10CodeA: MedicineSelectorIcd10Code,
   icd10CodeB: MedicineSelectorIcd10Code
): 1 | 0 | -1 => {
   if (icd10CodeA.main !== icd10CodeB.main) {
      return icd10CodeA.main ? -1 : 1;
   }
   return 0;
};
